import React, { useState } from "react"
import { Link } from "gatsby"

import Layout from "../../components/Layout"
import SEO from "../../components/seo"
import Header from "../../components/Header"
import Table from "../../components/Table"
import Pagination from "../../components/Pagination"

import Search from './../../images/icons/search.png'
import Arrow from './../../images/icons/arrow-bg.png'

export default () => {
  const [page, setPage] = useState(1)
  return (
    <div className="slideInTop">
      <SEO title="Home" />
      <Header />
      <Layout className="p-32">
        <h3 className="m-0 text-shadow font-16 pr-16">قوانین و استانداردها</h3>
        <hr className="mb-0" />
        <div className="p-32 modal-content">
          <div className="grid" style={{
            gridTemplateColumns: 'repeat(3, 1fr)',
            gridColumnGap: 32
          }}>
            <button
              className="bd-none py-8 px-16 radius-4 text-shadow iran-sans" style={{ backgroundColor: 'rgba(255, 255, 255, .7)' }}>
              <span className="font-14">کتابخانه</span>
            </button>
            <Link to="/library/rules-qa-afzoodeh">
              <button
                className="bd-none w-100 py-8 px-16 radius-4 text-shadow iran-sans" style={{ backgroundColor: 'rgba(255, 255, 255, .4)' }}>
                <span className="font-14">قانون مالیات بر ارزش افزوده</span>
              </button>
            </Link>
            <Link to="/library/rules-qa-mostagim">
              <button
                className="bd-none w-100 py-8 px-16 radius-4 text-shadow iran-sans" style={{ backgroundColor: 'rgba(255, 255, 255, .4)' }}>
                <span className="font-14">قانون مالیات های مستقیم</span>
              </button>
            </Link>
          </div>
          <div className="p-16 radius-4 mt-32" style={{ backgroundColor: 'rgba(255, 255, 255, .7)' }}>
            <div className="flexed justify-between">
              <h5 className="m-0 pb-8 pr-16">لطفا موضوع مورد نظر را انتخاب کنید</h5>
              <button className="bd-none bg-none icon-button mx-16 p-0">
                <img className="icon-sm valign-mid button" src={Search} alt="" />
              </button>
            </div>
            <hr />
            <div className="mx-8">
              <button className="bd-none bg-none icon-button ml-8 mr-16 p-0">
                <img className="icon-xs valign-mid button blocked" src={Arrow} alt="" />
              </button>
              <button className="font-8 bd-none bg-none iran-sans text-semi-disabled">کتابخانه</button>
              <span className="text-semi-disabled">&rsaquo;</span>
              <button className="font-8 bd-none bg-none iran-sans text-semi-disabled">حسابداری و حسابرسی</button>
              <span className="text-semi-disabled">&rsaquo;</span>
              <button className="font-8 bd-none bg-none iran-sans text-semi-disabled">استانداردهای حسابداری</button>
            </div>
            <div className="mt-16 mx-8 grid overflow-auto" style={{
              gridTemplateColumns: 'repeat(3, 1fr)',
              gridColumnGap: 32,
              maxHeight: 148
            }}>
              <button
                className="bd-none bg-none py-8 px-16 radius-4 iran-sans">
                <span className="font-10">کتابخانه</span>
              </button>
              <Link to="/">
                <button
                  className="bd-none bg-none w-100 py-8 px-16 radius-4 iran-sans">
                  <span className="font-10">قانون مالیات بر ارزش افزوده</span>
                </button>
              </Link>
              <Link to="/">
                <button
                  className="bd-none bg-none w-100 py-8 px-16 radius-4 iran-sans">
                  <span className="font-10">مالیات مستقیم</span>
                </button>
              </Link>
              <button
                className="bd-none bg-none py-8 px-16 radius-4 iran-sans">
                <span className="font-10">مالیات کتابخانه</span>
              </button>
              <Link to="/">
                <button
                  className="bd-none bg-none w-100 py-8 px-16 radius-4 iran-sans">
                  <span className="font-10">قانون بر ارزش افزوده</span>
                </button>
              </Link>
              <Link to="/">
                <button
                  className="bd-none bg-none w-100 py-8 px-16 radius-4 iran-sans">
                  <span className="font-10">قانون مالیات مستقیم</span>
                </button>
              </Link>
              <button
                className="bd-none bg-none py-8 px-16 radius-4 iran-sans">
                <span className="font-10">مالیات</span>
              </button>
              <Link to="/">
                <button
                  className="bd-none bg-none w-100 py-8 px-16 radius-4 iran-sans">
                  <span className="font-10">قانون بر افزوده</span>
                </button>
              </Link>
              <Link to="/">
                <button
                  className="bd-none bg-none w-100 py-8 px-16 radius-4 iran-sans">
                  <span className="font-10">قانون مالیات قانون</span>
                </button>
              </Link>
              <button
                className="bd-none bg-none py-8 px-16 radius-4 iran-sans">
                <span className="font-10">مالیات کتابخانه</span>
              </button>
              <Link to="/">
                <button
                  className="bd-none bg-none w-100 py-8 px-16 radius-4 iran-sans">
                  <span className="font-10">قانون بر ارزش افزوده</span>
                </button>
              </Link>
              <Link to="/">
                <button
                  className="bd-none bg-none w-100 py-8 px-16 radius-4 iran-sans">
                  <span className="font-10">قانون مالیات مستقیم</span>
                </button>
              </Link>
              <button
                className="bd-none bg-none py-8 px-16 radius-4 iran-sans">
                <span className="font-10">مالیات کتابخانه</span>
              </button>
              <Link to="/">
                <button
                  className="bd-none bg-none w-100 py-8 px-16 radius-4 iran-sans">
                  <span className="font-10">قانون بر ارزش افزوده</span>
                </button>
              </Link>
              <Link to="/">
                <button
                  className="bd-none bg-none w-100 py-8 px-16 radius-4 iran-sans">
                  <span className="font-10">قانون مالیات مستقیم</span>
                </button>
              </Link>
            </div>
          </div>
        </div>
        <Table
          className="p-32"
          showRowIndex
          headers={[
            { title: '‫ردیف‬', size: 1 },
            { title: 'تاریخ تصویب', size: 3 },
            { title: 'شماره', size: 3 },
            { title: 'نوع', size: 3 },
            { title: 'عنوان', size: 6 },
          ]}
          rows={[
            { link: '/library/rule', data: ['‫‪۱۳۹۸/۱۲/۰۸‬‬', '‫‪۰۰۹۹۵۲۵۱۴۵۸۷۵۹‬‬', 'آرای دیوان عدالت اداری', 'ابلاغ صورتجلسه شورای عالی مالیاتابهام مطرح شده در ارتباط با مرجع اعتراض و متن الکی'] },
            { link: '/library/rule', data: ['‫‪۱۳۹۸/۱۲/۰۸‬‬', '‫‪۰۰۹۹۵۲۵۱۴۵۸۷۵۹‬‬', 'آرای دیوان عدالت اداری', 'ابلاغ صورتجلسه شورای عالی مالیاتابهام مطرح شده در ارتباط با مرجع اعتراض و متن الکی'] },
            { link: '/library/rule', data: ['‫‪۱۳۹۸/۱۲/۰۸‬‬', '‫‪۰۰۹۹۵۲۵۱۴۵۸۷۵۹‬‬', 'آرای دیوان عدالت اداری', 'ابلاغ صورتجلسه شورای عالی مالیاتابهام مطرح شده در ارتباط با مرجع اعتراض و متن الکی'] },
            { link: '/library/rule', data: ['‫‪۱۳۹۸/۱۲/۰۸‬‬', '‫‪۰۰۹۹۵۲۵۱۴۵۸۷۵۹‬‬', 'آرای دیوان عدالت اداری', 'ابلاغ صورتجلسه شورای عالی مالیاتابهام مطرح شده در ارتباط با مرجع اعتراض و متن الکی'] },
            { link: '/library/rule', data: ['‫‪۱۳۹۸/۱۲/۰۸‬‬', '‫‪۰۰۹۹۵۲۵۱۴۵۸۷۵۹‬‬', 'آرای دیوان عدالت اداری', 'ابلاغ صورتجلسه شورای عالی مالیاتابهام مطرح شده در ارتباط با مرجع اعتراض و متن الکی'] },
            { link: '/library/rule', data: ['‫‪۱۳۹۸/۱۲/۰۸‬‬', '‫‪۰۰۹۹۵۲۵۱۴۵۸۷۵۹‬‬', 'آرای دیوان عدالت اداری', 'ابلاغ صورتجلسه شورای عالی مالیاتابهام مطرح شده در ارتباط با مرجع اعتراض و متن الکی'] },
          ]} />
        <Pagination currentPage={page} count={15} setPage={setPage} />
      </Layout>
    </div>
  )
}
